import React, { useState, useMemo, useContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Navigation from "../components/navigation"

import ProcessSlider from "../components/process-slider"
import Clients from "../components/clients"
import ProcessNav from "../components/process-nav"
import useRedirectToLang from "../hooks/useRedirectToLang"
import { ViewportContext } from "../contexts/viewport-context"

const ProzessZhPage = () => {
  const [state, setState] = useState("process")
  const dimensions = useContext(ViewportContext)
  useRedirectToLang("/cn/process")

  const handleButtonClick = wantedState => {
    if (state !== wantedState) setState(wantedState)
  }

  return (
    <>
      <SEO title="Prozess" lang="zh" />
      <Layout width={dimensions[0]}>
        {dimensions[0] > 640 ? (
          <ProcessNav
            navState={state}
            buttonClick={handleButtonClick}
            lang="cn"
          />
        ) : null}
        {useMemo(
          () =>
            state === "process" ? (
              <ProcessSlider lang="cn">
                {dimensions[0] < 641 ? (
                  <ProcessNav
                    navState={state}
                    buttonClick={handleButtonClick}
                    lang="cn"
                  />
                ) : null}
              </ProcessSlider>
            ) : (
              <Clients lang="cn">
                {dimensions[0] < 641 ? (
                  <ProcessNav
                    navState={state}
                    buttonClick={handleButtonClick}
                    lang="cn"
                  />
                ) : null}
              </Clients>
            ),
          [state, dimensions[0]]
        )}
      </Layout>
      <Navigation path="/cn/process" lang="cn" width={dimensions[0]} />
    </>
  )
}

export default ProzessZhPage
